import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSkincare = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.2249 2.00427C10.5767 2.00406 10.8621 2.28355 10.8624 2.62846V21.3792C10.8626 21.7242 10.5776 22.004 10.2257 22.0042H3.8499C3.49809 22.0045 3.21266 21.725 3.2124 21.3801V2.62927C3.2122 2.28436 3.49722 2.00453 3.84907 2.00427H10.2249ZM19.1499 2.00427C19.503 2.00515 19.7883 2.28639 19.7874 2.63253C19.7874 2.64693 19.7868 2.66137 19.7857 2.67566L18.5107 19.5507C18.4855 19.8769 18.2086 20.1291 17.8749 20.1292H16.5999V20.7542H17.2374C17.5895 20.7542 17.8749 21.0342 17.8749 21.3792C17.8749 21.7245 17.5895 22.0042 17.2374 22.0042H14.6874C14.3353 22.0042 14.0499 21.7245 14.0499 21.3792C14.0499 21.0341 14.3353 20.7542 14.6874 20.7542H15.3249V20.1292H14.0499C13.7162 20.1291 13.4384 19.8769 13.4133 19.5507L12.1383 2.67566C12.1132 2.33037 12.3787 2.03048 12.7309 2.0059C12.7456 2.00483 12.7602 2.00432 12.7749 2.00427H19.1499ZM4.4874 9.50427V20.7542H9.5874V9.50427H4.4874ZM13.4605 3.25428L14.6409 18.8792H17.283L18.4634 3.25428H13.4605ZM4.4874 3.25428V8.25427H9.5874V3.25428H4.4874Z",
		fill: "currentColor"
	})
});
export default SvgSkincare;
